import type { CSSProperties } from 'react';

export const ICON_SIZES = {
  xs: 12,
  sm: 14,
  md: 16,
  lg: 20,
  xl: 24,
} as const;

export type IconSize = keyof typeof ICON_SIZES;

export const ICON_NAMES = [
  // Navigation
  'home',
  'dashboard',
  'inbox',
  'users',
  'bot',
  'book',
  'zap',
  'coin',
  'chart',
  'plug',
  'settings',
  'menu',
  'more-horizontal',
  'more-vertical',
  // UI
  'search',
  'filter',
  'plus',
  'minus',
  'x',
  'check',
  'chevron-up',
  'chevron-down',
  'chevron-left',
  'chevron-right',
  'arrow-up',
  'arrow-down',
  'arrow-up-right',
  'eye',
  'eye-off',
  'edit',
  'trash',
  'copy',
  'download',
  'upload',
  'external-link',
  'link',
  'refresh',
  'star',
  'bookmark',
  'bell',
  'mail',
  // Status
  'info',
  'success',
  'warning',
  'error',
  // Theme
  'sun',
  'moon',
  // Channels
  'whatsapp',
  'instagram',
  'facebook',
  'telegram',
  'webchat',
  'email',
  // Auth providers
  'google',
  'microsoft',
  // Misc
  'sparkles',
  'tag',
  'send',
  'paperclip',
  'note',
] as const;

export type IconName = (typeof ICON_NAMES)[number];

export interface SuperIconProps {
  name: IconName;
  size?: IconSize | number;
  color?: string;
  className?: string;
  style?: CSSProperties;
  /** Required when icon is the only content of a button. */
  accessibilityLabel?: string;
  strokeWidth?: number;
}
